import apiClient from '@u/apiClient.js'
import GetAnalyticsDataByDashboardIdController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController'
import GetAnalyticsDataController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataController'
import GetInvoiceItemStatisticsController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/GetInvoiceItemStatisticsController'
import ExportInvoiceItemDetailRowsController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/ExportInvoiceItemDetailRowsController'
import GetInvoiceItemDetailRowsController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/GetInvoiceItemDetailRowsController'
import GetInvoicingStatisticsController from '@/wayfinder/actions/App/Http/Controllers/AnalyticsDashboard/GetInvoicingStatisticsController'

export default {
  setType: ({ commit }, payload) => {
    commit('setType', payload)
  },
  setFilters: ({ commit }, payload) => {
    commit('setFilters', payload)
  },
  setXAxis: ({ commit }, payload) => {
    commit('setXAxis', payload)
  },
  getAnalyticsForDashboardData: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAnalyticsDataByDashboardIdController[
            '/api/analytics-dashboard/{analytics_dashboard}/analytics-data'
          ].post({ analytics_dashboard: payload.id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getAnalyticsData: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAnalyticsDataController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getInvoiceItemStatistics: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetInvoiceItemStatisticsController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  /**
   * One page of the article lines behind a chart period (BBSW-10691).
   */
  getInvoiceItemDetailRows: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetInvoiceItemDetailRowsController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  /**
   * CSV (blob) of every article line of a period, streamed by the API (BBSW-10691).
   */
  exportInvoiceItemDetailRows: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ExportInvoiceItemDetailRowsController.post(), payload, {
          responseType: 'blob'
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getInvoicingStatistics: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetInvoicingStatisticsController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
